import { FunctionComponent } from 'react';
import { HasChildren } from 'src/common/props';

export interface HeroFooterProps extends HasChildren {}

export const HeroFooter: FunctionComponent<HeroFooterProps> = ({ children }) => {
    return <footer>{children}</footer>;
};
